import React from "react";
import { useFormikContext } from "formik";
import getCourtById from "../helpers/getCourtById";
import { FlatApplciationType } from "../types";
import getCourtByPostcode from "../helpers/getCourtByPostcode";

interface UnsafeToContactInfoProps {
  usePostcode?: boolean;
}

const UnsafeToContactInfo = ({
  usePostcode = false,
}: UnsafeToContactInfoProps) => {
  const { values } = useFormikContext<FlatApplciationType>();

  const court = React.useMemo(() => {
    if (values.CourtID) {
      return getCourtById(values.CourtID);
    } else if (usePostcode) {
      if (!values.appl_det_addr_postcode) return null;
      return getCourtByPostcode(String(values.appl_det_addr_postcode));
    }
    
    return null;
  }, [usePostcode, values.appl_det_addr_postcode, values.CourtID]);

  return court ? (
    <>
      {usePostcode ? (
        <p>After you submit the application, you will need to contact:</p>
      ) : (
        <h2>After you submit the application, you will need to contact:</h2>
      )}
      <div>
        <strong>{court.name}</strong>
        <br />
        {court.address_line1}
        <br />
        {court.locality}
        <p>
          Please contact your local court within the next seven (7) business
          days.
        </p>
        <p>
          To find more details about this court, please click the link below.
          <br />
          <a
            href="https://www.mcv.vic.gov.au/going-court/find-court"
            title="Find a court"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.mcv.vic.gov.au/going-court/find-court
          </a>
        </p>
      </div>
    </>
  ) : null;
};

export default UnsafeToContactInfo;
